import React from 'react'

const PATHS = {
  bolt: <path d="M13 2 4 14h6l-1 8 9-12h-6z" />,
  trendUp: <path d="M3 17l6-6 4 4 8-8M15 6h6v6" />,
  trendDown: <path d="M3 7l6 6 4-4 8 8M15 18h6v-6" />,
  globe: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 010 18M12 3a14 14 0 000 18" /></>,
  barChart: <path d="M4 20V10M11 20V4M18 20v-7" />,
  shield: <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />,
  droplet: <path d="M12 3s6 6.5 6 11a6 6 0 01-12 0c0-4.5 6-11 6-11z" />,
  network: <><circle cx="6" cy="6" r="2.5" /><circle cx="18" cy="6" r="2.5" /><circle cx="12" cy="18" r="2.5" /><path d="M8 7l7-.5M7 8.5l4 7.5M17 8.5l-4 7.5" /></>,
  target: <><circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="4" /><circle cx="12" cy="12" r="0.7" fill="currentColor" stroke="none" /></>,
  bot: <><rect x="5" y="9" width="14" height="10" rx="2" /><path d="M12 5v4M9 14v0M15 14v0" /><circle cx="9" cy="14" r="0.8" fill="currentColor" stroke="none" /><circle cx="15" cy="14" r="0.8" fill="currentColor" stroke="none" /></>,
  refresh: <path d="M4 4v5h5M20 20v-5h-5M4.5 15a8 8 0 0014.5 3.5M19.5 9A8 8 0 005 5.5" />,
  gear: <><circle cx="12" cy="12" r="3" /><path d="M12 3v2.5M12 18.5V21M21 12h-2.5M5.5 12H3M18.4 5.6l-1.8 1.8M7.4 16.6l-1.8 1.8M18.4 18.4l-1.8-1.8M7.4 7.4L5.6 5.6" /></>,
  layers: <><path d="M12 3l9 5-9 5-9-5 9-5z" /><path d="M3 13l9 5 9-5" /></>,
  shrink: <path d="M9 15H4v5M15 9h5V4M15 15h5v5M9 9H4V4" />,
  infinity: <path d="M7 15a4 4 0 010-8c2.5 0 4 2.5 5 4s2.5 4 5 4a4 4 0 000-8c-2.5 0-4 2.5-5 4s-2.5 4-5 4z" />,
  headset: <path d="M4 13a8 8 0 0116 0v4a2 2 0 01-2 2h-1v-6h3M4 17v-4a2 2 0 012-2h1v6H6a2 2 0 01-2-2z" />,
  chartCandlestick: <path d="M6 6v3M6 9h0M6 9v6M6 15h0M6 15v3M12 4v5M12 9h0M12 9v9M12 18h0M12 18v2M18 8v3M18 11h0M18 11v6M18 17h0M18 17v3" />,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></>,
  messageSquare: <path d="M4 4h16v12H8l-4 4V4z" />,
  contactCard: <><rect x="4" y="4" width="16" height="16" rx="2" /><circle cx="9.5" cy="10" r="2" /><path d="M6.5 16c0-1.8 1.5-3 3-3s3 1.2 3 3M14 9h4M14 13h4" /></>,
  download: <path d="M12 3v12M7 10l5 5 5-5M4 19h16" />,
}

export function Icon({ name, size = 20, strokeWidth = 1.8 }) {
  const path = PATHS[name] || PATHS.barChart
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {path}
    </svg>
  )
}
